import { Pipe, PipeTransform } from '@angular/core'
import { displayNameOf } from './utils/corp-member.util'

@Pipe({
  name: 'displayName',
})
export class DisplayNamePipe implements PipeTransform {
  transform(member: Parameters<typeof displayNameOf>[0]): string {
    return displayNameOf(member)
  }
}
